// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>12</span>&nbsp;&nbsp;My foot stands firm;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;in the great congregation I will bless the Lord.<br> </p> </div></div>";
// Exports
module.exports = code;